import { IAccess, IAccessListItem, AccessResponseType } from "./access.types";

export default class Access implements  IAccess {
    total: number;
    data: IAccessListItem[] = [];
    constructor(data: AccessResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}